import { Button, Popconfirm } from 'antd';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RemoveIcon } from '~/img';

interface DeleteButtonProps {
  onConfirm?: () => void;
  onClick?: () => void;
  loading?: boolean;
  wihoutConfirm?: boolean;
}

const DeleteButton: FC<DeleteButtonProps> = (props) => {
  const { onConfirm, loading, wihoutConfirm = false, onClick } = props;
  const [t] = useTranslation();

  if (wihoutConfirm) return <Delete loading={loading} onClick={onClick} />;
  return (
    <Popconfirm
      title={t('areYouSure')}
      okText={t('yes')}
      cancelText={t('no')}
      onConfirm={onConfirm}
    >
      <Delete loading={loading} />
    </Popconfirm>
  );
};

interface DeleteProps {
  onClick?: () => void;
  loading?: boolean;
}

const Delete: FC<DeleteProps> = (props) => {
  const { loading, onClick } = props;
  const [t] = useTranslation();
  return (
    <Button danger type="text" icon={<RemoveIcon />} onClick={onClick} loading={loading}>
      {t('delete')}
    </Button>
  );
};

export default DeleteButton;
